/* eslint-disable array-callback-return */
/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useEffect } from 'react'

import { Swiper, SwiperSlide } from 'swiper/react'

import Leaflet from 'leaflet'

import 'leaflet/dist/leaflet.css'

import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'

import { Autoplay } from 'swiper'

import { notify } from '../../../components/Toast'
import { ToastContainer } from 'react-toastify'

import './InternalMenu.scss'

import Logo from '../../../assets/svg/logoEnglish.svg'
import persianLogo from '../../../assets/pictures/persianLogo.png'
import persianDarkLogo from '../../../assets/pictures/persianLogoDark.png'

import iconUrl from '../../../assets/svg/Location.svg'

import { get, post } from '../../../services/https'

import { MapContainer, TileLayer, Marker } from 'react-leaflet'
import { baseUrl } from '../../../services/base'
import { ToRial } from '../../../services/money'

export const newicon = new Leaflet.Icon({
  iconUrl,
  iconAnchor: [5, 55],
  popupAnchor: [10, -44],
  iconSize: [45, 55]
})

function index() {
  const [categories, setCategory] = useState([])
  // eslint-disable-next-line no-unused-vars
  const [categorySelect, setCategorySelect] = useState('all')
  const [foods, setFoods] = useState([])
  const [showFood, setShowFood] = useState(false)
  const [food, setFood] = useState({
    name: 'name',
    price: '0',
    discountPrice: '0',
    pic: '',
    description: '',
    status: true
  })

  const [name, setName] = useState('')
  const [nameAlert, setNameAlert] = useState(false)

  const [fatherName, setFatherName] = useState('')
  const [fatherNameAlert, setFatherNameAlert] = useState(false)

  const [birthday, setBirthday] = useState('')
  const [birthdayAlert, setBirthdayAlert] = useState(false)

  const [meliCode, setMeliCode] = useState('')
  const [meliCodeAlert, setMeliCodeAlert] = useState(false)

  const [phoneNumber, setPhoneNumber] = useState('')
  const [phoneNumberAlert, setPhoneNumberAlert] = useState(false)

  const [cityBorn, setCityBorn] = useState('')
  const [cityBornAlert, setCityBornAlert] = useState(false)

  const [relation, setRelation] = useState('')
  const [relationAlert, setRelationAlert] = useState(false)

  const [instagramId, setInstagramId] = useState('')
  const [instagramIdAlert, setInstagramIdAlert] = useState(false)

  const [experienceHave, setExperienceHave] = useState('')
  const [experienceHaveAlert, setExperienceHaveAlert] = useState(false)

  const [experiencePart, setExperiencePart] = useState('')
  const [experiencePartAlert, setExperiencePartAlert] = useState(false)

  const [shift, setShift] = useState('')
  const [shiftAlert, setShiftAlert] = useState(false)

  const [education, setEducation] = useState('')
  const [educationAlert, setEducationAlert] = useState(false)

  const [buttonStatus, setButtonStatus] = useState(false)

  const [sliders, setSliders] = useState([])
  const [banners, setBanners] = useState([])

  const position = [37.27579, 49.937]
  const Markers = () => {
    return (
      <Marker
        key={position}
        position={position}
        interactive={false} 
        icon={newicon}
      />
    )
  }

  useEffect(() => {
    get('/api/front/im/categories/667d4494a687e05ec5c66dff')
      .then(response => {
        setCategory(response.data.data)
      }).catch(error => {
        notify('error', 'دریافت اطلاعات با خطا مواجه شد')
      })

    get('/api/front/im/foods')
      .then(response => {
        setFoods(response.data.data)
      }).catch(error => {
        notify('error', 'دریافت اطلاعات با خطا مواجه شد')
      })

    get('/api/front/im/sliders')
      .then(response => {
        setSliders(response.data.data.docs[0].slider)
      }).catch(error => {
        notify('error', 'دریافت اطلاعات با خطا مواجه شد')
      })

    get('/api/front/im/banners')
      .then(response => {
        setBanners(response.data.data.docs[0].banners)
      }).catch(error => {
        notify('error', 'دریافت اطلاعات با خطا مواجه شد')
      })
  }, [])

  const categoryHandler = (e) => {
    setCategorySelect(e.target.id)
    const id = e.target.id

    window.scrollTo({ top: 250, behavior: 'smooth' })
    if (id === 'all'){
      get(`/api/front/im/foods`)
      .then(response => {
        return setFoods(response.data.data)
      })
      .catch(error => {
        return notify('error', 'دریافت اطلاعات با خطا مواجه شد')
      })
    } else {
      get(`/api/front/im/foods/cat/${id}`)
        .then(response => {
          return setFoods(response.data.data)
        })
        .catch(error => {
          return notify('error', 'دریافت اطلاعات با خطا مواجه شد')
        })
    }
  }

  const showFoodHandler = (e) => {
    const id = e.target.id
    if(id != 'foodCard') {
      setShowFood(true)
      foods.map(item => {
        item.data.map(food => {
          if (food._id === id) {
            setFood({
              name: food.name,
              price: ToRial(food.price),
              discountPrice: ToRial(food.discountPrice),
              pic: `${baseUrl.base}${food.pic}`,
              description: food.description,
              status: food.status
            })
          }
        })
      })
    }
  }

  const formHandler = () => {
    console.log(birthday.day)
    if (name.length > 3) {
      setNameAlert(false)
    } else {
      setNameAlert(true)
    }

    if (fatherName.length > 2) {
      setFatherNameAlert(false)
    } else {
      setFatherNameAlert(true)
    }

    if (birthday.length > 5) {
      setBirthdayAlert(false)
    } else {
      setBirthdayAlert(true)
    }

    if (meliCode.length > 3) {
      setMeliCodeAlert(false)
    } else {
      setMeliCodeAlert(true)
    }

    if (phoneNumber.length > 9) {
      setPhoneNumberAlert(false)
    } else {
      setPhoneNumberAlert(true)
    }

    if (cityBorn.length > 3) {
      setCityBornAlert(false)
    } else {
      setCityBornAlert(true)
    }

    if (relation.length > 3) {
      setRelationAlert(false)
    } else {
      setRelationAlert(true)
    }

    if (instagramId.length > 3) {
      setInstagramIdAlert(false)
    } else {
      setInstagramIdAlert(true)
    }

    if (experienceHave.length > 3) {
      setExperienceHaveAlert(false)
    } else {
      setExperienceHaveAlert(true)
    }

    if (experiencePart.length > 3) {
      setExperiencePartAlert(false)
    } else {
      setExperiencePartAlert(true)
    }

    if (shift.length > 3) {
      setShiftAlert(false)
    } else {
      setShiftAlert(true)
    }

    if (education.length > 3) {
      setEducationAlert(false)
    } else {
      setEducationAlert(true)
    }


    if (name.length > 3 &&
      fatherName.length > 2 &&
      birthday.day > 0 &&
      meliCode.length > 3 &&
      phoneNumber.length > 9 &&
      cityBorn.length > 3 &&
      relation.length > 3 &&
      instagramId.length > 3 &&
      experienceHave.length > 3 &&
      experiencePart.length > 3 &&
      shift.length > 3 &&
      education.length > 3) {
        post('/api/front/im/jobs', {
          name,
          fatherName,
          birthday: `${birthday.year}/${birthday.month}/${birthday.day}`,
          meliCode,
          phoneNumber,
          cityBorn,
          relation,
          instagramId,
          experienceHave,
          experiencePart,
          shift,
          education
        }).then(response => {
          if (response.data.success) {
            notify('success', 'فرم با موفقیت ارسال شد')
            setButtonStatus(true)
          }
        }).catch(error => {
          notify('error', 'دریافت اطلاعات با خطا مواجه شد')
        })
      }
  }
  
  return (
    <div className='InternalMenu'>
      <ToastContainer rtl />
      <div style={showFood ? { display: '' } : { display: 'none' }}>
        <div className='singleFoodInternal'>
          <div className='singleFoodBody'>
            <div className='singleFoodPic'>
              <img src={food.pic} alt='pic' />
              <span className='hasBeen' style={food.status ? {display: 'none'} : {display: ''}}>ناموجود</span>
            </div>
            <div className='singleFoodTitle'>
              {food.name}
            </div>
            <div className='singleFoodSubitle'>
              {food.description}
            </div>
            <div className='singleFoodDetail' style={food.status ? { display: '' } : { display: 'none' }}>
              <span style={food.discountPrice != 0 ? { fontSize: '12px', textDecoration: 'line-through' } : {}}>{food.price} تومان</span>
              <span style={food.discountPrice == 0 ? { display: 'none' } : {}}>{food.discountPrice} تومان</span>
              <span className='singleFoodAdd' style={{ display : 'none' }}></span>
            </div>
            <button className='singleFoodButton' onClick={() => setShowFood(false)}>
              بازگشت به منو
            </button>
          </div>
        </div>
      </div>
      <div className='countainer'>
        <div className='InternalMenu_logo'>
          <img src={Logo} alt="Logo" />
        </div>

        <div className="internalMenu_subtitle">
          کانولی سمفونی طعم ها !!
        </div>

        <div className="InternalMenu_category_title">
          دسته بندی مورد نظر را انتخاب کنید :
        </div>

        <div className="InternalMenu_category_countainer">
          <div className="InternalMenu_category_item" id="all" onClick={categoryHandler}>
            تمامی منو
          </div>
          {categories.map(item => (
            <div className="InternalMenu_category_item" key={item._id} id={item._id} onClick={categoryHandler}>
              <img src={`${baseUrl.base}${item.icon}`} alt="CategoryIcon" id={item._id} />
              {item.title}
            </div>
          ))}
        </div>
          
        {foods ? foods.map(item =>
          item.category[0].shop == '667d4494a687e05ec5c66dff' ? (
          <>
            <div className="InternalMenu_category_top" key={item._id}>
              | {item.category[0].title} |
            </div>
            <div className="InternalMenu_foods_countainer">
              {item.data.map(food => 
                food.shop == '667d4494a687e05ec5c66dff' ? (
                <section className='InternalMenu_foods_card' id={food._id} key={food._id} onClick={showFoodHandler}>
                  <div className="InternalMenu_foods_card_pic" id={food._id}>
                    <img src={`${baseUrl.base}${food.pic}`} alt="image2" id={food._id} />
                  </div>
                  <div className="InternalMenu_foods_card_details" id={food._id}>
                    <span id={food._id}>{food.name}</span>
                    <span id={food._id}>{(food.description).substring(0, 35) + ' ... '}</span>
                    <span id={food._id} className='InternalMenu_foods_card_details_price'>
                      <span id={food._id} style={food.discountPrice != 0 ? { fontSize: '12px', textDecoration: 'line-through' } : {}}>{ToRial(food.price)} تومان</span>
                      <span id={food._id} style={food.discountPrice == 0 ? { display: 'none' } : {}}>{ToRial(food.discountPrice)} تومان</span>
                    </span>
                  </div>
                </section>
              ) : '')}
            </div>
          </>
            ) : ''
          ) : ''}

        <div className='InternalMenu_banners'>
          {banners ? banners.map((item, index) => (
            <a href={item.link} key={index}>
              <img src={item.pic} alt="bannerOne" />
            </a>
          )) : ''}
        </div>

        <div className="internalMenu_subtitle">
          کانولی سمفونی طعم ها !!
        </div>

        <Swiper 
          spaceBetween={20}
          slidesPerView={4}
          autoplay={{
            delay: 5500,
            disableOnInteraction: false,
          }}
          pagination={{
            clickable: true,
          }}
          modules={[Autoplay]}
          style={{ padding: '1em 0 0 0' }}
          >
            {sliders ? sliders.map((item, index) => (
                <SwiperSlide className='swiperSlide' key={index}>
                  <a href={item.sliderLink}>
                    <img src={item.sliderPicture} alt='sliderOne' width='100%' height='100%' />
                  </a>
                </SwiperSlide>
            )) : ''}
        </Swiper>
        <div className="InternalMenu_job_countainer">
          <div className="InternalMenu_job_right">
            <div className="InternalMenu_job_title">
              فرم درخواست همکاری
            </div>
            <div className="InternalMenu_job_sutitle">
              برای همکاری با مجموعه کانولی ، لطفا فرم زیر را تکمیل نموده <br />
              و منتظر تماس همکاران ما باشید.
            </div>
            <div className="InternalMenu_job_logo">
              <img src={persianLogo} alt="persianLogo" />
            </div>
            <div className="InternalMenu_job_sutitle">
              اینجانب با آگاهی و با صداقت کامل به پرسش های فوق پاسخ<br />
              دادم،چنانچه خلاف آن ثابت شود،مجموعه اجازه دارد بصورت<br />
              یکطرفه بنده را اخراج یا برخورد قانونی نماید.
            </div>
            <div className="InternalMenu_job_btn">
              <button onClick={formHandler} style={buttonStatus ? { display: 'none' } : { display: '' }}>
                ثبت اطلاعات
              </button>
            </div>
          </div>
          <div className="InternalMenu_job_form">
            <div className='InternalMenu_job_form_countainer'>
              <section>
                <label htmlFor="">نام و نام خانوادگی : </label>
                <input type="text" onChange={e => {
                  setName(e.target.value)
                }} />
                <small style={nameAlert ? { display: '' } : { display: 'none' }}>نام خانوادگی صحیح نیست</small>
              </section>
              <section>
                <label htmlFor="">نام پدر : </label>
                <input type="text" onChange={e => {
                  setFatherName(e.target.value)
                }}/>
                <small style={fatherNameAlert ? { display: '' } : { display: 'none' }}>نام پدر صحیح نیست</small>
              </section>
            </div>
            <div className='InternalMenu_job_form_countainer'>
              <section>
                <label htmlFor="">تاریخ تولد  : </label>
                <input type="text" onChange={e => {
                  setBirthday(e.target.value)
                }}/>
                <small style={birthdayAlert ? { display: '' } : { display: 'none' }}>تاریخ صحیح نیست</small>
              </section>
              <section>
                <label htmlFor="">کد ملی :</label>
                <input type="text" onChange={e => {
                  setMeliCode(e.target.value)
                }}/>
                <small style={meliCodeAlert ? { display: '' } : { display: 'none' }}>کد ملی صحیح نیست</small>
              </section>
            </div>
            <div className='InternalMenu_job_form_countainer'>
              <section>
                <label htmlFor="">تلفن همراه : </label>
                <input type="text" onChange={e => {
                  setPhoneNumber(e.target.value)
                }}/>
                <small style={phoneNumberAlert ? { display: '' } : { display: 'none' }}>شماره موبایل صحیح نیست</small>
              </section>
              <section>
                <label htmlFor="">شهر محل سکونت  :</label>
                <input type="text" onChange={e => {
                  setCityBorn(e.target.value)
                }}/>
                <small style={cityBornAlert ? { display: '' } : { display: 'none' }}>شهر محل سکونت صحیح نیست</small>
              </section>
            </div>
            <div className='InternalMenu_job_form_countainer'>
              <section>
                <label htmlFor="">وضعیت تاهل : </label>
                <select name="" id="" onChange={e => setRelation(e.target.value)}>
                  <option value="">انتخاب کنید</option>
                  <option value="مجرد">مجرد</option>
                  <option value="متاهل">متاهل</option>
                </select>
                <small style={relationAlert ? { display: '' } : { display: 'none' }}>جنسیت صحیح نیست</small>
              </section>
              <section>
                <label htmlFor="">شناسه اینستاگرام  :</label>
                <input type="text" onChange={e => setInstagramId(e.target.value)} />
                <small style={instagramIdAlert ? { display: '' } : { display: 'none' }}>شناسه اینستاگرام صحیح نیست</small>
              </section>
            </div>
            <div className='InternalMenu_job_form_countainer'>
              <section>
                <label htmlFor="">سابقه کاری مرتبط به کافه رستوران دارید ؟</label>
                <select name="" id="" onChange={e => setExperienceHave(e.target.value)}>
                  <option value="">انتخاب کنید</option>
                  <option value="دارم">دارم</option>
                  <option value="ندارم">ندارم</option>
                </select>
                <small style={experienceHaveAlert ? { display: '' } : { display: 'none' }}>سابقه کاری صحیح نیست</small>
              </section>
              <section>
                <label htmlFor="">تمایل به همکاری در کدام بخش را دارید؟ </label>
                <select name="" id="" onChange={e => setExperiencePart(e.target.value)}>
                  <option value="">انتخاب کنید</option>
                  <option value="حسابداری">حسابداری</option>
                  <option value="کانتر">کانتر</option>
                  <option value="گارسن">گارسن</option>
                  <option value="آشپزخانه">آشپزخانه</option>
                </select>
                <small style={experiencePartAlert ? { display: '' } : { display: 'none' }}>بخش همکاری صحیح نیست</small>
              </section>
            </div>
            <div className='InternalMenu_job_form_countainer'>
              <section>
                <label htmlFor="">تمایل به همکاری در کدام شیفت را دارید؟ </label>
                <select name="" id="" onChange={e => setShift(e.target.value)}>
                  <option value="">انتخاب کنید</option>
                  <option value="صبح تا عصر">صبح تا عصر</option>
                  <option value="عصر تا شب">عصر تا شب</option>
                </select>
                <small style={shiftAlert ? { display: '' } : { display: 'none' }}>شیفت صحیح نیست</small>
              </section>
              <section>
                <label htmlFor="">آخرین مدرک تحصیلی</label>
                <input type="text" onChange={e => setEducation(e.target.value)}/>
                <small style={educationAlert ? { display: '' } : { display: 'none' }}>آخرین مدرک تحصیلی صحیح نیست</small>
              </section>
            </div>
          </div>
        </div>

        <div className='InternalMenu_footer'>
          <div className='InternalMenu_footer_left'>
            <img src={persianDarkLogo} alt="persianDarkLogo" />
            <span className='InternalMenu_footer_left_subtitle'>
              کانولی سمفونی طعم ها !!
            </span>
            <span>
              شماره های تماس :
            </span>
            <span>
              013-42135632 ،  013-42135632
            </span>
            <address>
              آدرس : آستانه اشرفیه ، میدان جمهوری
            </address>
          </div>
          <div className='InternalMenu_footer_center'>
            <span className='InternalMenu_footer_center_title'>
              لینک های دسترسی 
            </span>
            <ul>
              <li><a href="/internalMenu">منوی آنلاین</a></li>
              <li><a href="/internalMenu/reserve">رزرو میز</a></li>
              <li><a href="/internalMenu/job">استخدام</a></li>
              <li><a href="/internalMenu/faq">سوالات پر تکرار</a></li>
            </ul>
          </div>
          <div className='InternalMenu_footer_right'>
            <MapContainer 
              style={{ width: '350px', height: '300px', margin: '1em 0 0 0' }}
              center={position} 
              zoom={14}
              >
              <TileLayer
                attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.osm.org/{z}/{x}/{y}.png"
              />
              <Markers />
            </MapContainer>
          </div>
        </div>

        <div className="copyright">
          <span>کلیه ی حقوق مادی و معنوی این وبسایت متعلق به مجموعه کانولی است</span>
          <span>طراحی و توسعه توسط : <a href="https://ham-team.ir">هم تیم</a></span>
        </div>
      </div>
    </div>
  )
}

export default index